import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import styles from 'react-placeholder/lib/reactPlaceholder.css';
import { LazyStylesComponent } from './LazyStylesComponent';
var SkeletonLoader = function (_a) {
    var children = _a.children, placeholder = _a.placeholder, ready = _a.ready;
    return (React.createElement(LazyStylesComponent, { styles: styles, identifier: "skeleton" },
        React.createElement(ReactPlaceholder, { ready: ready, customPlaceholder: placeholder }, children)));
};
export default SkeletonLoader;
